import { Dimmer, Grid, Loader, Table } from "semantic-ui-react";
import { CommonTable } from "../../../../components/commonTable/CommonTable";
import { SupplierIngredientTabCol } from "../../../../config/tableColConstant";
import { useMemo, useState } from "react";
import {
  useCheckIngredientInMapping,
  useDeleteIngredient,
  useGetSupplierIngredients,
  usePutSupplierData
} from "../../../../api/ingredients";
import { MdDeleteOutline, MdModeEditOutline } from "react-icons/md";
import IngredientEditModal from "../../ingredientEdit/IngredientEditModal";
import ConfirmModal from "../../../../components/confirmViewModal/ConfirmModal";
import { errorView, successMessage } from "../../../../helpers/ErrorHandler";
import { SupplierType } from "../../../../config/enums/SupplierType.enum";

const SupplierIngredientTab = ({ ingredientDetails }: any) => {
  const [visibleEditModal, setVisibleEditModal] = useState(false);
  const [editIngredientData, setEditIngrdientData] = useState();
  const [showDeleteIngredientModal, setShowDeleteIngredientModal] = useState(false);
  const [deleteIngredientData, setDeleteIngrdientData] = useState<any>({});

  const sourceId = useMemo(() => ingredientDetails?.ingredient_id, [ingredientDetails]);
  const ownerId = useMemo(() => ingredientDetails?.supplier_id, [ingredientDetails]);

  const {
    data: supplierIngredientDetails,
    isLoading: loadingSupplierIngredientDetails,
    refetch: refetchSupplierIngredients
  } = useGetSupplierIngredients({ sourceId, ownerId });

  const getIngredientForEditDetails = (detailsToEdit: any) => {
    setEditIngrdientData(detailsToEdit);
    setVisibleEditModal(true);
  };
  const { isLoading: isIngredientInMappingLoading, mutate: isIngredientInMapping } =
    useCheckIngredientInMapping();

  const { isLoading: isIngredientDeleteLoading, mutate: deleteIngredient } = useDeleteIngredient();

  const { isLoading, mutateAsync: mutatePutSupplier } = usePutSupplierData();

  const getIngredientToDelete = (detailsToEdit: any) => {
    setDeleteIngrdientData(detailsToEdit);
    setShowDeleteIngredientModal(true);
  };

  const checkIngredientInMapping = () => {
    isIngredientInMapping(
      {
        ingredientId: deleteIngredientData?.ingredient_id,
        supplierId: deleteIngredientData?.supplier_id
      },
      {
        onSuccess: (exists: boolean) => {
          if (exists) {
            errorView("Ingredient is used in drawing tool, Please remove it first");
            setShowDeleteIngredientModal(false);
            return;
          }
          handleIngredientDelete();
        }
      }
    );
  };

  const handleIngredientDelete = () => {
    deleteSupplier();
    deleteIngredient(deleteIngredientData, {
      onSuccess() {
        setDeleteIngrdientData({});
        refetchSupplierIngredients();
      }
    });
    setShowDeleteIngredientModal(false);
  };

  const deleteSupplier = () => {
    let supplierIngredient = deleteIngredientData.supplierIngredientIds.filter(
      (e: any) => e != deleteIngredientData.ingredient_id
    );
    let supplierUpdate = {
      _id: deleteIngredientData.supplier_id,
      supplier_name: deleteIngredientData.supplier_name,
      ingredientIds: supplierIngredient ? supplierIngredient : []
    };
    mutatePutSupplier(supplierUpdate, {
      onSuccess() {
        successMessage("Supplier removed from ingredient successfully");
        setDeleteIngrdientData({});
      }
    });
  };

  const loadTableData = () => {
    const ingredientData = supplierIngredientDetails?.map((ingredient: any) => {
      return {
        ingredient_id: ingredient.ingredientData?._id,
        ingredient_name: ingredient?.ingredientData?.ingredient_name,
        supplier_id:
          ingredient?.ingredientData?.suppliers[0]?.supplierIngredientDetails[0]?.supplier_id ||
          null,
        supplier_name: ingredient?.ingredientData?.suppliers[0]?.supplier_name,
        supplier_type:
          ingredient?.ingredientData?.suppliers?.supplier_type || SupplierType.External,
        supplierAsUser: ingredient?.ingredientData?.suppliers?.is_supplier_as_user || false,
        supplierIngredientDetails:
          ingredient?.ingredientData?.suppliers[0]?.supplierIngredientDetails?.find(
            (ingDetail: any) => ingDetail?.ingredient_id === ingredient.ingredientData?._id
          ) || null,
        ingredientProductIds: ingredient?.ingredientData?.productIds || [],
        supplierProductIds: ingredient?.ingredientData?.suppliers[0]?.productIds || [],
        supplierIngredientIds: ingredient?.ingredientData?.suppliers[0]?.ingredientIds || [],
        supplierCount: ingredient?.ingredientData?.supplierCount || 0,
        ingredient_image_path: ingredient?.ingredientData?.ingredient_image_path
      };
    });

    return (
      <>
        {ingredientData?.map((dataView: any, index: number) => {
          return (
            <Table.Row className="tbleR" key={index}>
              <Table.Cell>
                <p>{dataView.ingredient_name}</p>
              </Table.Cell>
              <Table.Cell>
                <p>{dataView.supplier_name}</p>
              </Table.Cell>
              <Table.Cell>
                <p>
                  {dataView?.supplierIngredientDetails?.unit_size +
                    dataView?.supplierIngredientDetails?.unit_type}
                </p>
              </Table.Cell>
              <Table.Cell>
                <p>{dataView?.supplierIngredientDetails?.ean_bar_code}</p>
              </Table.Cell>
              <Table.Cell>
                <MdModeEditOutline
                  cursor={"pointer"}
                  onClick={() => {
                    getIngredientForEditDetails(dataView);
                  }}
                  size={24}
                  color="var(--tableEditIcon)"
                />
              </Table.Cell>
              <Table.Cell>
                <MdDeleteOutline
                  cursor={"pointer"}
                  onClick={() => {
                    getIngredientToDelete(dataView);
                  }}
                  size={24}
                  color="var(--tableEditIcon)"
                />
              </Table.Cell>
            </Table.Row>
          );
        })}
      </>
    );
  };

  if (
    loadingSupplierIngredientDetails ||
    isIngredientInMappingLoading ||
    isIngredientDeleteLoading ||
    isLoading
  ) {
    return (
      <Dimmer active>
        <Loader content="Loading" />
      </Dimmer>
    );
  }

  return (
    <>
      <Grid>
        {supplierIngredientDetails?.length >= 0 ? (
          <Grid.Column computer={16} tablet={16} mobile={16} className="productRegisterTable">
            <CommonTable tableHeaderData={SupplierIngredientTabCol}>{loadTableData()}</CommonTable>
          </Grid.Column>
        ) : null}
      </Grid>
      {visibleEditModal ? (
        <IngredientEditModal
          ingredientIdToUpdate={editIngredientData}
          visibleModal={visibleEditModal}
          setVisibleModal={() => setVisibleEditModal(false)}
          refetchIngredients={refetchSupplierIngredients}
        />
      ) : null}
      <ConfirmModal
        viewModal={showDeleteIngredientModal}
        closeModal={() => setShowDeleteIngredientModal(false)}
        cancel={() => {
          setShowDeleteIngredientModal(false);
          setDeleteIngrdientData({});
        }}
        approve={() => {
          checkIngredientInMapping();
        }}
        title="Delete Ingredient Data"
        subTitle="Are you sure you want to remove this ingredient?"
      />
    </>
  );
};

export default SupplierIngredientTab;
